import call_778 from '@/assets/audio/RE380f28249c3ffec6057062ab021ad4aa.wav';

// -------------------- Campaign Dummy API --------------------
const campaigns = [
  {
    id: 1,
    name: "Heart Awareness Campaign",
    platforms: ["GOOGLE_MICROSOFT_BING"],
    flight_start_date: "2024-06-01",
    flight_end_date: "2024-06-30",
    spend: 12000,
    budget: 15000,
    cost_per_lead: 25,
    cost_per_action: 45,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  }
];

export const getCampaigns = async () => {
  return { campaigns, total_count: campaigns.length };
};

export const upsertCampaign = async ({ input }) => {
  const newCampaign = {
    ...input.campaigns,
    id: campaigns.length + 1,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  };
  campaigns.push(newCampaign);
  return { campaigns, total_count: campaigns.length };
};

// -------------------- Segment Dummy API --------------------
const segments = [/* your segments array here */]; // Use your original content

export const getSegments = async () => {
  return { segments, total_count: segments.length };
};

export const upsertSegment = async ({ input }) => {
  const newSegment = {
    ...input.segments,
    id: segments.length + 1,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  };
  segments.push(newSegment);
  return { segments, total_count: segments.length };
};

export const deleteSegment = async ({ id }) => {
  const index = segments.findIndex(segment => segment.id === id);
  if (index !== -1) {
    segments.splice(index, 1);
    return { success: true };
  }
  return { success: false };
};

// -------------------- Dashboard Stats --------------------
const delay = (ms) => new Promise(res => setTimeout(res, ms));


export const getDashboardStats = async () => {
  //await delay(200);
  return mockDashboardStats;
};

// -------------------- Studies Dummy API --------------------
const studies = [
  {
    id: 1,
    name: "Diabetes Prevention Study",
    sites: ["Cairo Clinic", "Giza Health Center"],
    status: "green",
    coordinator: "Dr. Laila Mostafa",
    protocol_file: "diabetes_study_protocol.pdf",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  }
];

export const getStudies = async () => {
  return { studies, total_count: studies.length };
};

export const upsertStudy = async ({ input }) => {
  const newStudy = {
    id: studies.length + 1,
    name: input.name || "Untitled Study",
    sites: input.sites || [],
    status: input.status || "yellow",
    coordinator: input.coordinator || null,
    protocol_file: input.protocol_file || null,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  };
  studies.push(newStudy);
  return { studies, total_count: studies.length };
};


// -------------------- Dummy Dashboard Stats --------------------

const mockDashboardStats = {
  totalOutreach: {
    yearly: 2450,
    monthly: 215,
    weekly: 50
  },

  totalOutreachChartData: {
    yearly: [
      { label: "Jan", value: 1500 },
      { label: "Feb", value: 1600 },
      { label: "Mar", value: 1750 },
      { label: "Apr", value: 2000 },
      { label: "May", value: 2300 },
      { label: "Jun", value: 2500 },
      { label: "Jul", value: 2700 },
      { label: "Aug", value: 2800 },
      { label: "Sep", value: 2900 },
      { label: "Oct", value: 3000 },
      { label: "Nov", value: 3100 },
      { label: "Dec", value: 3200 }
    ]
    // Optional: Add monthly/weekly chartData
  },

  callAnalysis: {
    yearly: {
      totalCalls: 890,
      avgCallDuration: "4m 12s",
      successfulCalls: 612,
      droppedCalls: 45
    },
    monthly: {
      totalCalls: 80,
      avgCallDuration: "4m 05s",
      successfulCalls: 70,
      droppedCalls: 3
    },
    weekly: {
      totalCalls: 20,
      avgCallDuration: "3m 55s",
      successfulCalls: 18,
      droppedCalls: 1
    }
  },

  topLocations: {
    yearly: [
      { location: "New York", count: 432 },
      { location: "Los Angeles", count: 321 },
      { location: "Chicago", count: 198 },
      { location: "Dallas", count: 247 },
      { location: "San Francisco", count: 198 },
      { location: "Austin", count: 144 }
    ],
    monthly: [
      { location: "New York", count: 120 },
      { location: "Miami", count: 90 },
      { location: "Seattle", count: 60 },
      { location: "Dallas", count: 247 },
      { location: "San Francisco", count: 198 },
      { location: "Austin", count: 144 }
    ],
    weekly: [
      { location: "Chicago", count: 30 },
      { location: "New York", count: 25 },
      { location: "Austin", count: 20 },
      { location: "Dallas", count: 247 },
      { location: "San Francisco", count: 198 },
      { location: "Austin", count: 144 }
    ]
  },

  callOutcomes: {
    yearly: [
      {
        month: "Jan",
        answered: 300,
        unanswered: 150,
        voicemail: 100,
        scheduled: 80,
        not_interested: 50
      },
      {
        month: "Feb",
        answered: 320,
        unanswered: 160,
        voicemail: 90,
        scheduled: 85,
        not_interested: 55
      }
    ],
    monthly: [
      {
        month: "Jan",
        answered: 30,
        unanswered: 15,
        voicemail: 10,
        scheduled: 8,
        not_interested: 5
      },
      {
        month: "Feb",
        answered: 32,
        unanswered: 16,
        voicemail: 9,
        scheduled: 8.5,
        not_interested: 5.5
      }
    ]
  },

upcomingAppointments: [
  { action: 'Appointment', status: 'QUEUED', channel: 'Voice Inbound', full_name_first: "Nora Ramirez", last_contact_started_at: "2025-05-21T09:30:00.00Z", next_retry_at: "2025-05-21T09:30:00.00Z", subject_id: 2050, type: "Call" },
  { action: 'Post-call', status: 'QUEUED', channel: 'Text Outbound', full_name_first: "Owen Brown", last_contact_started_at: "2025-05-22T11:15:00.00Z", next_retry_at: "2025-05-22T11:15:00.00Z", subject_id: 2049, type: "SMS" },
  { action: 'Follow-up Message', status: 'QUEUED', channel: 'Email Outbound', full_name_first: "Lucas Gonzalez", last_contact_started_at: "2025-05-22T11:15:00.00Z", next_retry_at: "2025-05-23T14:45:00.00Z", subject_id: 2048, type: "Email" },
  { action: 'Appointment', status: 'QUEUED', channel: 'Voice Outbound', full_name_first: "Lucas Anderson", last_contact_started_at: "2025-05-22T11:15:00.00Z", next_retry_at: "2025-05-24T10:00:00.00Z", subject_id: 2047, type: "Call" },
  { action: 'Appointment', status: 'QUEUED', channel: 'Text Outbound', full_name_first: "Logan Garcia", last_contact_started_at: "2025-05-22T11:15:00.00Z", next_retry_at: "2025-05-25T16:20:00.00Z", subject_id: 2046, type: "SMS" },
  { action: 'Appointment', status: 'QUEUED', channel: 'Voice Inbound', full_name_first: "Harper Hernandez", last_contact_started_at: "2025-05-22T11:15:00.00Z", next_retry_at: "2025-05-24T10:00:00.00Z", subject_id: 2045, type: "Call" },
  { action: 'Appointment', status: 'QUEUED', channel: 'Text Inbound', full_name_first: "Hannah Robinson", last_contact_started_at: "2025-05-22T11:15:00.00Z", next_retry_at: "2025-05-02T16:20:00.00Z", subject_id: 2044, type: "SMS" },
  { action: 'Appointment', status: 'QUEUED', channel: 'Email Inbound', full_name_first: "Nora Martinez", last_contact_started_at: "2025-05-22T11:15:00.00Z", next_retry_at: "2025-05-23T14:45:00.00Z", subject_id: 2043, type: "Email" },
  { action: 'Appointment', status: 'QUEUED', channel: 'Voice Outbound', full_name_first: "Scarlett Thompson", last_contact_started_at: "2025-05-22T11:15:00.00Z", next_retry_at: "2025-05-24T10:00:00.00Z", subject_id: 2042, type: "Call" }
]
,


  recentInquiries: [
    { name: "Mike Johnson", method: "Email", date: "2025-05-18" },
    { name: "Anna Bell", method: "Text", date: "2025-05-17" }
  ],

  topOutreachMethodsByPeriod: {
    yearly: [
      { method: "Phone", count: 1400 },
      { method: "Email", count: 650 },
      { method: "SMS", count: 480 }
    ],
    monthly: [
      { method: "Phone", count: 120 },
      { method: "Email", count: 50 },
      { method: "SMS", count: 35 }
    ],
    weekly: [
      { method: "Phone", count: 30 },
      { method: "Email", count: 12 },
      { method: "SMS", count: 9 }
    ]
  }
};

export const engagementSummary = [
  {
    channel: "Voice Inbound",
    created_at: "2025-07-02T09:00",
    full_name_first: "Nora Ramirez",
    outcome: "Completed Call",
    next_contact_at: "2025-07-12T09:00",
    recording_url: call_778,
    subject_id: 2050,
    summary: 'The call began with an introduction to the MASH study. The patient\'s eligibility was confirmed based on age, height, and weight. An appointment was scheduled for September 30 at 12:00 PM to discuss further details and confirm eligibility. The patient inquired about compensation but was informed it would be discussed during the in-person appointment.',
    transcript: [
      {"channel_label": "ch_1", "start_time": 1.19660425186157, "end_time": 1.19660902023315, "transcript": "Hello."},
      {"channel_label": "ch_0", "start_time": 2.89372611045837, "end_time": 2.89373087882996, "transcript": "Hi there! This is Ava from General Medical Research on a recorded line calling about the MASH study. Are you Nora?"},
      {"channel_label": "ch_1", "start_time": 11.1763937473297, "end_time": 11.1763985157013, "transcript": "Yeah, it's me."},
      {"channel_label": "ch_0", "start_time": 11.8902897834778, "end_time": 11.8902945518494, "transcript": "Nice to speak with you Nora. Is now a good time to talk?"},
      {"channel_label": "ch_1", "start_time": 16.2187654972076, "end_time": 16.2187702655792, "transcript": "Sure."},
      {"channel_label": "ch_0", "start_time": 18.8287658691406, "end_time": 18.8287706375122, "transcript": "Great! I'm going to ask a few questions to determine your eligibility. If you don't want to or don't feel comfortable, please let me know and we can skip them. Could you please tell me your age?"},
      {"channel_label": "ch_1", "start_time": 30.7558085918427, "end_time": 30.7558133602142, "transcript": "I am thirty-four."},
      {"channel_label": "ch_0", "start_time": 31.5240676403046, "end_time": 31.5240724086761, "transcript": "Thank you. And how tall are you? Please provide your height in feet and inches."},
      {"channel_label": "ch_1", "start_time": 39.6873536109924, "end_time": 39.687358379364, "transcript": "I'm about five feet and four inches."},
      {"channel_label": "ch_0", "start_time": 40.5451471805573, "end_time": 40.5451519489288, "transcript": "Got it, 5 feet 4 inches. And what’s your weight in pounds?"},
      {"channel_label": "ch_1", "start_time": 47.5729012489319, "end_time": 47.5729060173035, "transcript": "222 pounds."},
      {"channel_label": "ch_0", "start_time": 51.6216413974762, "end_time": 51.6216461658478, "transcript": "Thanks for sharing that information. Based on what you've told me, you do qualify for the study. The next step would be to schedule an appointment at our clinic to go over more details and see if you’re fully eligible. Would you like to go ahead and set up a time for that?"},
      {"channel_label": "ch_1", "start_time": 65.2875738143921, "end_time": 65.2875785827637, "transcript": "Okay."},
      {"channel_label": "ch_0", "start_time": 66.5739924907684, "end_time": 66.57399725914, "transcript": "We have an appointment available on Tuesday, September 16th at 9:00 AM. Does that time work for you?"},
      {"channel_label": "ch_1", "start_time": 74.997663974762, "end_time": 74.9976687431335, "transcript": "No thank you."},
      {"channel_label": "ch_0", "start_time": 76.0171036720276, "end_time": 76.0171084403992, "transcript": "No problem. How about Tuesday, September 16th at 10:00 AM?"},
      {"channel_label": "ch_1", "start_time": 84.913985490799, "end_time": 84.9139902591705, "transcript": "What's the latest available day in September and the latest available time?"},
      {"channel_label": "ch_0", "start_time": 86.6306087970734, "end_time": 86.630613565445, "transcript": "The latest available day in September is Tuesday, September 30th, and the latest time that day is 12:00 PM. Would that work for you?"},
      {"channel_label": "ch_1", "start_time": 95.3836600780487, "end_time": 95.3836648464203, "transcript": "Yeah, that works."},
      {"channel_label": "ch_0", "start_time": 100.254765987396, "end_time": 100.254770755768, "transcript": "Great! Just to confirm, we have your appointment set for Tuesday, September 30th at 12:00 PM. The location for your appointment is at 541 South Orlando Ave, Suite 100, Maitland, Florida. Please bring your photo ID and a current list of medications. We will send you a follow-up text reminder with this information. Do you have any other questions for me?"},
      {"channel_label": "ch_1", "start_time": 122.896788597107, "end_time": 122.896793365479, "transcript": "Am I get paid for this study?"},
      {"channel_label": "ch_0", "start_time": 123.954199314117, "end_time": 123.954204082489, "transcript": "That will be discussed at the in-person appointment with the medical provider. Do you have any other questions?"},
      {"channel_label": "ch_1", "start_time": 130.984612703323, "end_time": 130.984617471695, "transcript": "No, that's all, thank you."},
      {"channel_label": "ch_0", "start_time": 132.393135309219, "end_time": 132.393140077591, "transcript": "You're welcome! Have a great day, and the General staff looks forward to seeing you in person. Goodbye."}
    ]
  },
  {
    channel: "Voice Outbound",
    created_at: "2025-07-02T09:00",
    full_name_first: "Owen Brown",
    outcome: "Voicemail Left",
    next_contact_at: "2025-07-12T09:00",
    subject_id: 2049,
    summary: 'An outbound call was placed to Owen regarding a pending update. Owen did not pick up, and the agent left a voicemail with callback information.',
    transcript: [
      { channel_label: 'ch_1', "start_time": 0, "end_time": 0, transcript: "*Phone rings, no answer. Voicemail beep.*" },
      { channel_label: 'ch_0', "start_time": 1, "end_time": 1, transcript: "Hi Owen, this is a courtesy call from the support team. We just wanted to follow up regarding your recent inquiry. Please give us a call back at 555-123-4567 at your convenience. Thank you, and have a great day." }
    ]
  },
  {
    channel: "Text Inbound",
    created_at: "2025-07-02T09:05",
    full_name_first: "Lucas Gonzalez",
    outcome: "Responded",
    next_contact_at: "2025-07-12T09:05",
    subject_id: 2048,
    summary: 'Lucas replied via text message to confirm that she had received the appointment reminder and would be on time. This inbound response closed the loop on her notification.',
    transcript: [
      { channel_label: 'ch_1', "start_time": 0, "end_time": 0, transcript: "Hi, just confirming I got the reminder. I’ll be there at 2:30 tomorrow as scheduled." },
      { channel_label: 'ch_0', "start_time": 1, "end_time": 1, transcript: "Great! We look forward to seeing you." }
    ]
  },
  {
    channel: "Text Outbound",
    created_at: "2025-07-02T09:05",
    full_name_first: "Logan Garcia",
    outcome: "Needs Follow-Up",
    next_contact_at: "2025-07-12T09:05",
    subject_id: 2046,
    summary: 'A text message was sent to Logan requesting confirmation of availability. No response was received, and follow-up will be necessary.',
    transcript: [
      { channel_label: 'ch_0', "start_time": 0, "end_time": 0, transcript: "Hello Logan, this is a quick reminder to confirm if you’re available for Thursday’s session. Please reply YES or NO so we can finalize scheduling." }
    ]
  },
  {
    channel: "Email Inbound",
    created_at: "2025-07-02T09:10",
    full_name_first: "Hannah Robinson",
    outcome: "Opened Email",
    next_contact_at: "2025-07-12T09:10",
    subject_id: 2044,
    summary: 'An inbound email was delivered to Hannah’s account. She opened the message, but did not provide a reply yet. Engagement is being tracked.',
    transcript: [
      { channel_label: 'ch_0', "start_time": 0, "end_time": 0, transcript: "Email titled 'Your Upcoming Appointment' was opened by Hannah Robinson." }
    ]
  },
  {
    channel: "Email Outbound",
    created_at: "2025-07-02T09:10",
    full_name_first: "Scarlett Thompson",
    outcome: "Confirmed Meeting",
    next_contact_at: "2025-07-12T09:10",
    subject_id: 2042,
    summary: 'An email was sent to Scarlett requesting confirmation for a scheduled meeting. He replied promptly, confirming attendance.',
    transcript: [
      { channel_label: 'ch_0', "start_time": 0, "end_time": 0, transcript: "Hello Scarlett, I wanted to confirm our meeting for Thursday, July 10th at 2:00 PM. Please let us know if this time still works for you." },
      { channel_label: 'ch_1', "start_time": 1, "end_time": 1, transcript: "Yes, that works perfectly. Please keep me on the schedule for Thursday at 2:00. Thanks for reaching out!" }
    ]
  }
];
